import classNames from "classnames";
import { ReactElement, ReactNode } from "react";
import styles from "./FilterSearch.module.scss";

export type FilterSearchProps = {
  search: ReactElement;
  action?: ReactNode;
  filter?: ReactNode | ReactNode[];
  variant?: 'small' | 'full-width'
};

export function FilterSearch({ search, action, filter, variant = 'small' }: FilterSearchProps) {
  return (
    <div className={styles.header}>
      <div className={classNames(styles.left, styles[variant])}>
        {search}
        {filter}
      </div>
      {action}
    </div>
  );
}
